import React, { Component } from 'react';
import SocialMediaLinksData from '../../models/socialinks';

class Footer extends Component {
  render() {
    let socialmedialinksdata = SocialMediaLinksData;
    return (
      <footer className="fixed-bottom bg-body-tertiary text-center pb-nav-footer">
        <div className="container pt-4">
          <section className="mb-4">
            {
              socialmedialinksdata.map((item, index) => {
                return <a data-mdb-ripple-init className="btn btn-link btn-floating btn-lg text-body m-1" role="button" data-mdb-ripple-color="dark" key={index} href={item.url} target="_blank" rel="noopener noreferrer"><i className={item.classname}></i></a>
              })
            }
          </section>
        </div>
      </footer>
    );
  }
}

export default Footer;
